<template>
  <v-form v-model="valid">
    <v-card :disabled="lockPersonalSettings">
      <v-card-title>
        {{ $t('settings.blacklist.title') }}&nbsp;
        <cp-help i18n="blacklist"/>
      </v-card-title>
      <div class="pl-4" v-for="(line, linePosition) in blacklist_numbers" v-bind:key="linePosition">
        <v-row>
          <v-col cols="4" sm="4">
            <v-text-field :label="$t('settings.blacklist.name')"
              :rules="[validator]"
              v-model="line.name">
            </v-text-field>
          </v-col>
          <v-col cols="8" sm="6">
            <v-text-field :label="$t('settings.blacklist.num')"
              :hint="$t('settings.blacklist.hint')"
              :rules="numberValidator()"
              v-model="line.number"
              prepend-icon="mdi-phone-cancel">
            </v-text-field>
          </v-col>
          <v-row class="ml-4 mt-6">
            <v-btn text color="red" icon class="mr-2"
              @click="deleteLine(linePosition)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <v-btn text color="primary" icon
              @click="addLine()">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-row>
        </v-row>
      </div>
      <v-divider></v-divider>
      <v-card-actions>
        <v-icon color="red" class="mr-3" v-if="lockPersonalSettings" small>mdi-lock</v-icon>
        <v-btn text @click="save" :disabled="!valid || lockPersonalSettings" class="save-btn">
          {{ $t('settings.blacklist.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'settings-blacklist',
  data: () => ({
    valid: false
  }),
  watch: {
    blacklistData (newVal) {
      if (newVal.length === 0) {
        this.addLine()
      }
    }
  },
  computed: {
    ...mapGetters({
      isOwnerCurUser: 'settings/isOwnerCurUser',
      blacklistData: 'settings/blacklist'
    }),
    lockPersonalSettings: function () {
      return !this.isOwnerCurUser
    },
    localBlacklist: function () {
      return this.blacklistData.map(n => {
        return { id: n.id, name: n.name, number: n.number }
      })
    },
    blacklist_numbers: { get () { return this.localBlacklist }, set (blacklist) { this.saveBlacklist(blacklist) } }
  },
  methods: {
    ...mapActions({
      addBlacklist: 'settings/addBlacklist',
      removeBlacklist: 'settings/removeBlacklist',
      setBlacklist: 'settings/setBlacklist',
      saveAllBlacklist: 'settings/saveAllBlacklist'
    }),
    addLine () {
      this.addBlacklist({ id: '', name: '', number: '' })
    },
    deleteLine (linePosition) {
      this.removeBlacklist(this.localBlacklist[linePosition])
      if (this.blacklist_numbers.length === 0) {
        this.addLine()
      }
    },
    saveBlacklist (blacklist) {
      this.setBlacklist(blacklist)
    },
    validator (value) {
      return value.length > 0 || this.$t('settings.blacklist.errRequired')
    },
    numberValidator () {
      return [
        v => (v && /^[0-9 ()\-+]+$/.test(v)) || this.$t('settings.blacklist.errInvalid'),
        v => (v && this.blacklist_numbers.filter(n => n.number === v).length === 1) || this.$t('settings.blacklist.errExists', { num: v })
      ]
    },
    save () {
      this.saveAllBlacklist(this.blacklist_numbers)
    }
  }
}
</script>

<style scoped>
</style>
